import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiStandardsRunUsage } from "./constants";
import type { GenerativeAiStandardsRunUsageResult } from "./types";
import { isGenerativeAiStandardsRunUsageResult } from "./validators";

/**
 * GET handler for the "/:app_group_id/generative_ai/standards_run_usage" endpoint
 */
export const getGenerativeAiStandardsRunUsage = reactQueryFetcherAdapter(
  generativeAiStandardsRunUsage,
  (signal: AbortSignal, appGroupId: string): Promise<GenerativeAiStandardsRunUsageResult> => {
    return fetch(`/${appGroupId}/generative_ai/standards_run_usage`, "GET", {}, { signal });
  },
  isGenerativeAiStandardsRunUsageResult
);
